import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface INavBar {
  id?: number;
  page_id?: number;
  component_id?: number;
  background_color?: string;
  hamburger_icon?: string;
  hamburger_icon_alt?: string;
  mobile_logo_icon?: string;
  mobile_logo_icon_alt?: string;
  logo_icon?: string;
  logo_icon_alt?: string;
  mobile_cancel_icon?: string;
  mobile_cancel_icon_alt?: string;
  program_name?: string;
  program_name_text_color?: string;
  horizontal_stripe_color?: string;
  status?: boolean;
}

export async function createNavBar(payload: Partial<INavBar>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.NAVBAR.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateNavBar(id: number, payload: Partial<INavBar>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.NAVBAR.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function getNavBarById(id: number) {
  try {
    const response = await adminAxios.get(
      ADMIN_API_ENDPOINTS.NAVBAR.GET_BY_ID(id)
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Clone navbar with all menu items from source to target
 * @param sourceNavbarId - ID of the source navbar to clone from
 * @param targetPageComponentId - Page component ID to link the cloned navbar to
 * @param targetNavbarId - Optional: If provided, updates existing navbar instead of creating new one
 * @returns Cloned navbar data with menu items
 */
export async function cloneNavBarWithMenuItems(
  sourceNavbarId: number,
  targetPageComponentId: number,
  targetNavbarId?: number | null
) {
  try {
    const response = await adminAxios.post(ADMIN_API_ENDPOINTS.NAVBAR.CLONE,
      {
        source_navbar_id: sourceNavbarId,
        target_page_component_id: targetPageComponentId,
        target_navbar_id: targetNavbarId || null,
      }
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
